import { useEffect, useState } from "react";
import { _size, _style, _typeLogo, url_telegram } from "../../core/core";
/* Code generated with AutoHTML Plugin for Figma */
import { useLocation } from "react-router";
import { useSupport } from "../../Support/SupportProvider";
import TelegramIcon from "../../assets/icons/telegram.svg?react";
import VuesaxLinearCategory from "../../assets/taiga-uikit/icons/category.svg?react";
import IconClose from "../../assets/taiga-uikit/icons/close-square.svg?react";
import VuesaxLinearDocument from "../../assets/taiga-uikit/icons/document.svg?react";
import VuesaxLinearHome from "../../assets/taiga-uikit/icons/home.svg?react";
import VuesaxLinearMessages3 from "../../assets/taiga-uikit/icons/messages-3.svg?react";
import VuesaxLinearUser from "../../assets/taiga-uikit/icons/user-octagon.svg?react";
import { Logo } from "../../components/Logo/Logo";
import { Link } from "../../components/link/link";
import KeyboardAware from "../../hooks/KeyboardAware";
import { useParameter } from "../../hooks/useParameter";
import "./MenuBottom.css";
const _modalType = { off: null, menu: "menu", button: "button", help: "help" };
type ModalType = typeof _modalType;
export const MenuBottom = ({ ...props }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [modalType, setModalType] = useState<string | null>(_modalType.off);
  const [isKeyboardOpen, setKeyboardOpen] = KeyboardAware();
  const { isOpen, openSupport, closeSupport } = useSupport();
  const [is_parameter, setIsParameter] = useParameter("chat", false, "boolean");
  const currentPage = useLocation();
  const currentMenu = (url: string) => {
    if (url == "/") return currentPage.pathname == "/";
    return currentPage.pathname.includes(url);
  };

  const handleMenuToggle = (modal: string | null) => {
    if (isOpen) {
      closeSupport();
    } else {
      openSupport();
    }
  };

  useEffect(() => {
    if (isAnimating) {
      const animationTimeout = setTimeout(() => {
        setIsAnimating(false);
        setIsMenuOpen(false);
      }, 300); // Duration of the closing animation in milliseconds

      return () => {
        clearTimeout(animationTimeout);
      };
    }
  }, [isAnimating, isMenuOpen]);

  const menuItems = [
    { href: "/", icon: <VuesaxLinearHome />, text: "Главная" },
    {
      onClick: () => {
        handleMenuToggle(_modalType.off);
      },
      icon: <VuesaxLinearMessages3 />,
      text: "Чат",
    },
    { href: "/uslugi/", icon: <VuesaxLinearDocument />, text: "Услуги" },
    { href: "/account/", icon: <VuesaxLinearUser />, text: "Профиль" },
    {
      onClick: () => {
        setIsMenuOpen(true);
        setModalType(_modalType.menu);
        if (typeof window !== "undefined") {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      },
      icon: <VuesaxLinearCategory />,
      text: "Меню",
    },
  ];

  const modalLinks = [
    { link: "/", text: "Главная" },
    { link: "/uslugi/", text: "Услуги" },
    { link: "/blog/", text: "Блог" },
    { link: "/account/", text: "Профиль" },
  ];

  return (
    <div className={`menu-bottom-fix menu-bottom-${!isKeyboardOpen}`}>
      <div className={`tab-bar tab-${modalType}`}>
        <div className="button-groups">
          {menuItems.map((item, index) =>
            item.href ? (
              <a key={index} href={item.href} className="button-menu">
                <div
                  className={`button-menu-body button-menu-${currentMenu(
                    item.href
                  )}`}
                >
                  {item.icon}
                  <p>{item.text}</p>
                </div>
              </a>
            ) : (
              <button
                key={index}
                onClick={item.onClick}
                className="button-menu"
              >
                <div className="button-menu-body">
                  {item.icon}
                  <p>{item.text}</p>
                </div>
              </button>
            )
          )}
        </div>
      </div>
      {isMenuOpen && (
        <div className="modal-area" onClick={() => setIsAnimating(true)}>
          <div
            className={`modal modal-${modalType} ${isAnimating ? "modal-hidden" : ""
              }`}
          >
            {modalType === _modalType.menu && (
              <>
                <div className="modal-header">
                  <Logo type={_typeLogo.white} />
                  <button className="button-menu modal-close">
                    <IconClose />
                  </button>
                </div>
                <div className="modal-body">
                  {modalLinks.map((link, index) => (
                    <Link
                      key={index}
                      link={link.link}
                      width="210px"
                      style={_style.clear2}
                      size={_size.M}
                    >
                      {link.text}
                    </Link>
                  ))}
                </div>
                <div className="modal-footer">
                  <Link style={_style.link} size={_size.M} link={"/blog/policy/"}>
                    Политика конфиденциальности
                  </Link>
                </div>
              </>
            )}
            {modalType === _modalType.button && (
              <div className="modal-body-help">
                <Link
                  blank
                  link={url_telegram}
                  width="100%"
                  size={_size.M}
                  icon_left={<TelegramIcon />}
                  style={_style.secondary2}
                >
                  Заказать
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
